import { Product } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import { ManagersSection } from '../Overview/components';
import { hasManagerContacts } from '../Overview/components/ManagersSection/ManagersSection';

interface ContactInfoTabProps {
  product: Product;
  isLoggedIn?: boolean;
}

export const hasContactInfo = (product: Product, isLoggedIn: boolean) =>
  (isLoggedIn && hasManagerContacts(product)) || !!product.cyberSecurityExpert;

export const ContactInfoTab = ({ product, isLoggedIn = false }: ContactInfoTabProps) => {
  const subject = `Automation Solution Finder - ${product.product}`;

  return (
    <>
      {isLoggedIn && <ManagersSection product={product} />}

      {product?.cyberSecurityExpert && (
        <Box sx={{ m: 2 }}>
          <Typography sx={{ mb: 1 }}>
            <strong>Cyber Security Product Expert - CSPE:</strong>{' '}
            <Typography component="span">{product.cyberSecurityExpert.name}</Typography>
            <Typography component="span"> - </Typography>
            <Box
              component="a"
              href={`mailto:${product.cyberSecurityExpert.email}?subject=${encodeURIComponent(subject)}`}
              target="_blank"
              rel="noreferrer"
              sx={{ cursor: 'pointer' }}
            >
              {product.cyberSecurityExpert.email}
            </Box>
          </Typography>
        </Box>
      )}
    </>
  );
};
